import React, { Component } from 'react';
import AiImageBigWrap from './AiImageBigWrap';
import Sticky  from "react-sticky-el";
import AiOptionSetWrap from './AiOptionSetWrap';
import AiToolbarWrap from './AiToolbarWrap';
import {OPTION_URL, DEFAULT_Z_QSKU} from '../constants';
//import {Button} from 'primereact/components/button/Button';

export var portraitReady = false

function callback(status) {
    //console.log('callback status',status);
}  

class MainBodyPortrait extends Component {
    componentDidMount() {
        portraitReady = true
    }

    render() {
        var splashScreen = (this.props.type === '0')
        var zsku=<div>{this.props.cfg}</div>
      if (window.currentSite ==='zales')
        zsku = <div>{DEFAULT_Z_QSKU}</div>
        
        return (<div id="ai-portrait-panel" className='ai-body'> 
        <div className={'ai-cfg-small' + (splashScreen ? ' hideStart' : '')}>SKU #{zsku}-{this.props.sh.slice(1)}</div>
        <div className='ai-title-small'>{this.props.title}</div>
       <Sticky  topOffset={0}  className='ai-sticky' disabled={this.props.showSticky} onFixedToggle={callback} > 
       <i className={'ai-startover-small' + (splashScreen ? ' hideStart' : '')}
        onClick={() => {if(this.props.isku!==this.props.sku){this.props.onStartOver()}}}>
        <img className="ai-startover-button" 
        src={OPTION_URL + "small/button/so3.png"} alt=""
        srcSet={OPTION_URL + "small/button/so3.png 1x, " +OPTION_URL + "large/button/so3.png 2x"}
        draggable="false"
        onDragStart={(e) => { e.preventDefault() }}
        />
        </i>
        <i className={'ai-zoom-small' + (splashScreen ? ' hideStart' : '')} >
        <img className="ai-zoom-button" 
        src={OPTION_URL + "small/button/z3.png"} 
        srcSet={OPTION_URL + "small/button/z3.png 1x, " +OPTION_URL + "large/button/z3.png 2x"}
        onClick={this.props.onPushOpenBox}
        alt=""
        draggable="false"
        onDragStart={(e) => { e.preventDefault() }}
        />
        </i> 
        <AiImageBigWrap 
        size={this.props.size} 
        className='ai-image-portrait' 
        orientation={this.props.orientation}/>
        <AiToolbarWrap className='ai-toolbar-panel' size={this.props.size}/>
        </Sticky>
        <div className={'ai-all-options' + (splashScreen ? ' hideStartPortrait' : '')}>
            <AiOptionSetWrap 
            imageSize={this.props.imageSize} 
            optionNumber={this.props.optionNumber} 
            optionSize={this.props.optionSize}
            orientation={this.props.orientation}/>
        </div>
        
        </div>
        );
    }
}


export default MainBodyPortrait;


// WEBPACK FOOTER //
// ./src/layout/MainBodyPortrait.js